import styled from 'styled-components'

export const ContainerLista = styled.div`
  width: 100%;
  flex: 1;
  gap: 10px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-right: 5px;

  .card__header {
    width: 100%;
    height: 100%;
    display: flex;
    margin-bottom: 10px;
  }

  .header__infos {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;

    div {
      background-color: #5d74d0;
      border-radius: 5px;
      align-items: center;
      justify-content: center;
      padding: 10px;
      font-size: 11px;
      font-weight: bold;
      color: white;
    }

    p {
      font-size: 14px;
      font-weight: bold;
      color: #5d74d0;
      margin: 0;
      padding: 0;
    }
  }

  .header__infos__buttons {
    width: 100%;
    height: 36px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 5px;
  }
`

export const CardListar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 2px solid #e1e1e1;
  border-radius: 7px;
  padding: 10px;
  /* Cards de análise fora da tela não pagam render (lista longa de análises). */
  content-visibility: auto;
  contain-intrinsic-size: auto 260px;

  .detalhes__analise {
    width: 100%;

    h3 {
      color: #757575;
      font-size: 13px;
      font-weight: 700;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .info__detalhes {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .detalhes {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .detalhes:is([data-active='true']) {
      padding: 10px;
      display: flex;
      flex-direction: column;
      background-color: #f6ffed;
      color: #5da57d;
      border-radius: 5px;
    }
  }

  .detalhes__observacao {
    width: 100%;
    padding-top: 10px;
    display: flex;
    flex-direction: column;

    span {
      color: #757575;
      font-size: 13px;
      font-weight: 700;
    }

    p {
      margin: 0;
      padding: 0;
    }
  }
`
